<template>
    <div ref="modalRef" id="updateCategoryModal" class="modal">
        <div class="modal-content">
            <div class="my-modal-header">
                <p class="modal-title">{{ isEditing ? 'Edit' : 'Add' }} Category</p>
            </div>
            <div class="modal-body">
                <div class="row-item admin-row">
                    <div class="input-content">
                        <span class="popup-input-name">Category Name</span>
                        <input type="text" v-virtual-keyboard v-model="category.name" />
                    </div>
                </div>
                <div class="row-item admin-row">
                    <div class="input-content">
                        <span class="popup-input-name">Category Color</span>
                        <input type="color" class="color-picker" v-model="category.color" />
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <div class="admin-btn disable-select admin-btn-secondary" @click="onCloseClicked()">Close</div>
                <div class="admin-btn disable-select" :class="{'disabled': category.name === ''}" @click="createOrEdit()">{{ isEditing ? 'Save' : 'Create' }} Category
                </div>
            </div>
        </div>
    </div>
</template>
<script>
/* eslint-disable no-unused-vars */
import { Category } from "@/scripts/js/forgeModels";
export default {
    name: 'UpdateCategoryPopup',
    props: ["category_to_update", "assetid"],
    data() {
        return {
            category: new Category(),
            sourceLevel: null,
        };
    },
    methods: {
        onCloseClicked() {
            this.category = new Category();
            this.$refs.modalRef.style.display = "none";
        },
        createOrEdit() {
            if (this.category.name == "") return;

            if (this.isEditing) {
                this.$emit("update_category", this.category);
            } else {
                this.category.assetId = this.assetid;
                this.$emit("add_new_category", this.category);
            }
            this.$refs.modalRef.style.display = "none";
            setTimeout(() => {
                this.category = new Category();
            }, 100)
        }
    },
    computed: {
        isEditing: function () {
            return this.category.id != 0;
        }
    },
    watch: {
        category_to_update: function (newVal, oldVal) {
            if (newVal) {
                this.category = newVal;
            }
        }
    }
}
</script>
<style >
#updateCategoryModal .modal-content {
    height: fit-content;
}

#updateCategoryModal .modal-body {
    margin-bottom: 15px;
}

#updateCategoryModal .my-modal-header {
    height: 30px !important;
}

#updateCategoryModal .my-modal-header .modal-title {
    margin: 0;
    font-weight: normal;
    color: var(--primary-color);
    font-size: 22px;
}

#updateCategoryModal .modal-footer div {
    width: 50%;
    padding: 5px;
    font-size: 13px;
    display: flex;
    align-items: center;
    justify-content: center;
}

#updateCategoryModal .row-item {
    height: auto;
}

#updateCategoryModal input {
    font-weight: normal;
}

#updateCategoryModal .color-picker {
    padding-left: 0px;
    cursor: pointer;
}
</style>